/**
 * @generated SignedSource<<d0f3b1ebb5c8c307af3eef0420668be6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DisplayType = "displayedToEveryone" | "displayedToSpecificUsers" | "notDisplayed" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ActionColumn_TreeNodeFragment$data = {
  readonly hasBeenPublishedOnce: boolean;
  readonly id: string;
  readonly structureDefinition: {
    readonly extension?: {
      readonly displayType?: DisplayType;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"ProjectExtendActionButtons_TreeNodeFragment">;
  readonly " $fragmentType": "ActionColumn_TreeNodeFragment";
};
export type ActionColumn_TreeNodeFragment$key = {
  readonly " $data"?: ActionColumn_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActionColumn_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActionColumn_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasBeenPublishedOnce",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "structureDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "extension",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayType",
                      "storageKey": null
                    }
                  ],
                  "type": "RootExtensionImpl",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "RootStructureDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectExtendActionButtons_TreeNodeFragment"
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "c3199ffb3e527ac87f63dd74b4f1b9b3";

export default node;
